
export default {
  name: 'Menu',
};
